export enum UTP2Groups {
  Conditions = "$GROUP_CONDITIONS",
  Job = "$GROUP_JOB",
  Substation = "$GROUP_SUB",
  Switchgear = "$GROUP_SWGR",
}

export enum UTP2Job {
  JobNo = "$JOB_NO",
  EngineerName = "$ENGINEER_NAME",
}

export enum UTP2GroupedConditions {
  BackMetal = "BackMetal",
  BackAir = "BackAir",
  TemperatureHumidity = "TemperatureHumidity",
}

export enum UTP2Conditions {
  BackMetalDbReading = "$BACK_METAL_DB",
  BackMetalPPCReading = "$BACK_METAL_PPC",
  BackAirDbReading = "$BACK_AIR_DB",
  BackAirPPCReading = "$BACK_AIR_PPC",
  TemperatureCelsius = "$TEMPERATURE_C",
  RelativeHumidity = "$HUMIDITY",
}

export const UTP2GroupedConditionsLookup: Record<UTP2GroupedConditions, UTP2Conditions[]> = {
  [UTP2GroupedConditions.BackMetal]: [UTP2Conditions.BackMetalDbReading, UTP2Conditions.BackMetalPPCReading],
  [UTP2GroupedConditions.BackAir]: [UTP2Conditions.BackAirDbReading, UTP2Conditions.BackAirPPCReading],
  [UTP2GroupedConditions.TemperatureHumidity]: [UTP2Conditions.TemperatureCelsius, UTP2Conditions.RelativeHumidity],
};

export enum UTP2Substations {
  SubstationType = "$SUB_TYPE",
  SubstationName = "$SUB_NAME",
  CableNaming = "$CABLE_NAMING",
}

export enum UTP2Switchgear {
  Manufacturer = "$SWGR_MNFR",
  Type = "$SWGR_TYPE",
  InstallDate = "$SWGR_INSTALL_DATE",
  RatedVoltage = "$SWGR_RATED_V",
  OperatingVoltage = "$SWGR_OPERATING_V",
  BusbarInsulation = "$BUSBAR_INSU",
}

export enum UTP2CustomQuestionTypes {
  Dropdown = "list",
  ExclusiveDropdown = "exclusive_list",
  TextInput = "text",
  Date = "date",
  Native = "native",
}

export enum CableNaming {
  L1L2L3 = "$L1_L2_L3",
  BrownBlackGrey = "$BRN_BLK_GREY",
  RedYellowBlue = "$RED_YEL_BLUE",
  RedWhiteBlue = "$RED_WHT_BLUE",
}

export enum SubstationType {
  Indoor = "$INDOOR",
  Outdoor = "$OUTDOOR",
  Cabinet = "$CABINET",
}

export enum UTP2EventHeadings {
  PeakAmplitude = "peak_amplitude",
  Amplitude = "amplitude",
  Integral = "integral",
  PhaseAngle = "phase_angle",
  CycleNumber = "cycle_number",
  RiseTime = "rise_time",
  PulseWidth = "pulse_width",
}
